// SlopeCalcDialog.tsx — Rise/run/angle converter (v11 slope calculator utility)

import { useState } from 'react';
import DialogBase from './DialogBase';

export default function SlopeCalcDialog() {
  const [rise,  setRise]  = useState(1);
  const [run,   setRun]   = useState(12);

  const slope   = run > 0 ? rise / run : 0;
  const degrees = (Math.atan(slope) * 180 / Math.PI).toFixed(3);
  const pct     = (slope * 100).toFixed(2);
  const ratio   = run > 0 ? `1:${(run / rise).toFixed(2)}` : '—';

  return (
    <DialogBase title="Slope Calculator" hideFooter={false} okLabel="Close">
      <div className="dialog-row">
        <label className="dialog-label">Rise</label>
        <input className="dialog-input sm" type="number" value={rise} step={0.125}
          onChange={e => setRise(parseFloat(e.target.value))} />
        <span className="dialog-unit">"</span>
      </div>
      <div className="dialog-row">
        <label className="dialog-label">Run</label>
        <input className="dialog-input sm" type="number" value={run} step={0.5}
          onChange={e => setRun(parseFloat(e.target.value))} />
        <span className="dialog-unit">"</span>
      </div>
      <div className="dialog-divider" />
      <div className="dialog-row result">
        <label className="dialog-label">Angle</label>
        <span className="result-value">{degrees}°</span>
      </div>
      <div className="dialog-row result">
        <label className="dialog-label">Percent</label>
        <span className="result-value">{pct}%</span>
      </div>
      <div className="dialog-row result">
        <label className="dialog-label">Ratio</label>
        <span className="result-value">{ratio}</span>
      </div>
    </DialogBase>
  );
}
